/**
 * Public certificate verification (spec §11, promoted to v1 by D-010).
 *
 * The response is deliberately thin. A customs officer needs to know the certificate is
 * genuine and current; they do not need the exporter's invoice values, and publishing
 * those to an unauthenticated endpoint would be a disclosure, not a feature.
 */
import { z } from 'zod';
import { verificationResultSchema } from './enums.js';
export const verifyRequestSchema = z.object({
    certificateNo: z.string().trim().min(3).max(60),
    /** Printed beside the number. Without it the number space is enumerable. */
    verificationCode: z.string().trim().min(4).max(12),
});
export const verifyResponseSchema = z.object({
    result: verificationResultSchema,
    certificate: z
        .object({
        certificateNo: z.string(),
        documentTypeName: z.string(),
        agreement: z.string().nullable(),
        issuingChamber: z.object({
            name: z.string(),
            logoUrl: z.string().nullable(),
            websiteUrl: z.string().nullable(),
        }),
        exporterName: z.string(),
        destinationCountry: z.string(),
        certificateDate: z.string(),
        issuedAt: z.string(),
    })
        .nullable(),
    /** Present for REVOKED and SUPERSEDED. The state must be unmistakable, not a subtle
     *  badge — someone is deciding whether to release a shipment on this. */
    status: z
        .object({
        revokedAt: z.string().nullable(),
        supersededByCertificateNo: z.string().nullable(),
        note: z.string().nullable(),
    })
        .nullable(),
    verifiedAt: z.string(),
});
//# sourceMappingURL=verification.js.map